/*
    Modulo Card
*/
import React from 'react';
import css from './avatar.module.less';
import {ClassName} from 'mgToolsKit';
import PropTypes from 'prop-types';

export default class Avatar extends React.Component{

   constructor(props, context){
        super(props);
    }

    render(){
        var  {theme} = this.context;
        var  arrayClassName = [css["mg-avatar"]];
        const  {className} = this.props;
        if(className != undefined){
            arrayClassName.push(className);
        }
        var _className = ClassName(arrayClassName);

        var styles = {
            /*color: theme.primaryColor,*/
            background: theme.primaryColor
        }
        return(
            <div style={styles} className={_className}>
                {this.props.children}
            </div>

        )
    }
}
Avatar.displayName = "AvatarUi";

// PropTypes validation
Avatar.propTypes = {
    className: PropTypes.string   
};

// default props
Avatar.defaultProps = {
};

Avatar.contextTypes = {
    /*
    * Context per la gestione del tema
    * */
    theme: PropTypes.object
}